export function marcasveiculosInRequest(params = {}) {
  return {
    type: '@marcasveiculo/MARCASVEICULOS_IN_REQUEST',
    payload: { params },
  };
}

export function findMarcasVeiculo(idmarcaveiculo) {
  return {
    type: '@marcasveiculo/FIND_MARCASVEICULO',
    payload: { idmarcaveiculo },
  };
}

export function failedRequest() {
  return {
    type: '@marcasveiculo/FAILED_REQUEST',
  };
}

export function deleteMarcasVeiculo(idmarcaveiculo, params) {
  return {
    type: '@marcasveiculo/DELETE_MARCASVEICULO',
    payload: { idmarcaveiculo, params },
  };
}

export function updateMarcasVeiculo(marcasveiculo, params) {
  return {
    type: '@marcasveiculo/UPDATE_MARCASVEICULO',
    payload: { marcasveiculo, params },
  };
}

export function storeMarcasVeiculo(marcasveiculo, params) {
  return {
    type: '@marcasveiculo/STORE_MARCASVEICULO',
    payload: { marcasveiculo, params },
  };
}

export function successInRequest(
  marcasveiculos,
  page,
  pageSize,
  totalCount,
  totalPages
) {
  return {
    type: '@marcasveiculo/SUCCESS_IN_REQUEST',
    payload: { marcasveiculos, page, pageSize, totalCount, totalPages },
  };
}

export function successRequest(marcasveiculo) {
  return {
    type: '@marcasveiculo/SUCCESS_REQUEST',
    payload: { marcasveiculo },
  };
}

export function successRemove(params) {
  return {
    type: '@marcasveiculo/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@marcasveiculo/RECORD_FILTERING',
    payload: { params },
  };
}
